import {useMemo, useState} from 'react';
import React from 'react';

import styles from './show-more-rows.module.scss';
import {useI18n} from '@udemy-v2/i18n';
import {Icon} from '@udemy-v2/icons';

export const ShowMoreRows = ({
    children,
    rowsToShow = 10,
    countPerRow = 1,
    ButtonComponent,
}: {
    children: React.ReactNode;
    rowsToShow: number;
    countPerRow: number;
    ButtonComponent: React.ElementType;
}) => {
    const rows = React.Children.toArray(children);
    const visibleRows = useMemo(
        () => rows.slice(0, rowsToShow * countPerRow),
        [rows, rowsToShow, countPerRow],
    );
    const showMore = rows.length > rowsToShow * countPerRow;
    const {gettext} = useI18n();
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <div
                className={styles['show-more-content-container']}
                data-purpose="show-more-content-container"
            >
                {expanded ? rows : visibleRows.map((row) => row)}
            </div>
            {showMore && !expanded && (
                <ButtonComponent
                    onClick={() => setExpanded(true)}
                    udStyle="ghost"
                    className={styles['show-more-button']}
                >
                    <Icon glyph="expand" label={false} className={styles['show-more']} />
                    {gettext('Show more')}
                </ButtonComponent>
            )}
            {showMore && expanded && (
                <ButtonComponent
                    onClick={() => setExpanded(false)}
                    udStyle="ghost"
                    className={styles['show-less-button']}
                >
                    <Icon glyph="collapse" label={false} className={styles['show-less']} />
                    {gettext('Show less')}
                </ButtonComponent>
            )}
        </>
    );
};
